import React from "react";

import { Form } from "affinityForm";
import { ExecuteButton } from "affinityForm/components/executeButton";
import { InputField, RangeField } from "affinityForm/fields";
import { Button, ButtonVariants } from "affinityUI/elements/button";
import { Card } from "affinityUI/elements/card";
import { Grid } from "affinityUI/elements/grid";
import { ButtonGroup, DataEntryGroup } from "affinityUI/form/components";

export const SettingsForm: React.FC<{
  onCancel: () => void;
}> = ({ onCancel: handleCancel }) => {
  return (
    <Card data-testid="settings-form">
      <Form>
        <DataEntryGroup
          title="Normal ranges"
          description="Set up normal ranges for the following parameters"
          id="normal-ranges"
        >
          <RangeField name="wbcRange">WBC (10⁹/L)</RangeField>
          <RangeField name="neutrophilRange">Neutrophils (10⁹/L)</RangeField>
          <RangeField name="haemoglobinRangeMale">Haemoglobin Male (g/L)</RangeField>
          <RangeField name="haemoglobinRangeFemale">Haemoglobin Female (g/L)</RangeField>
          <RangeField name="plateletRange">Platelets (10⁹/L)</RangeField>
        </DataEntryGroup>
        <DataEntryGroup
          title="Confirmatory blood test threshold"
          description="Set a threshold where a patient may need to have a confirmatory blood test."
          id="confirmatory-test"
        >
          <Grid $cols={[1, 1]}>
            <InputField type="number" name="neutrophilThreshold">
              Neutrophils (10⁹/L)
            </InputField>
          </Grid>
        </DataEntryGroup>
        <ButtonGroup>
          <Button variant={ButtonVariants.SECONDARY} onClick={handleCancel}>
            Cancel
          </Button>
          <ExecuteButton>Continue to confirmation</ExecuteButton>
        </ButtonGroup>
      </Form>
    </Card>
  );
};
